import { render, staticRenderFns } from "./TreadDetail.vue?vue&type=template&id=22e7985c&scoped=true"
import script from "./TreadDetail.vue?vue&type=script&lang=js"
export * from "./TreadDetail.vue?vue&type=script&lang=js"
import style0 from "./TreadDetail.vue?vue&type=style&index=0&id=22e7985c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e7985c",
  null
  
)

export default component.exports